export default {
  methods: {
    getApiUrl (action) {
      return process.env.ROOT_BIND_API + action
    },
    getBindApiUrl (type, action) {
      return process.env.ROOT_BIND_API + type + '/' + action
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind/mixins/ApiUrlMixin.js